// extracted by css-extract-rspack-plugin
export default {"select":"PerPage__select--Oge6B","small":"PerPage__small--PeF0R"};